import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import { withMobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger/BiLogger.context';
import GallectionSimpleView from './GallectionSimpleView';
import GallectionSearchView from './GallectionSearchView';
import GallectionEmptyState from './GallectionsEmptyState';
import { GallectionType } from '../../../../types/gallection';

export interface Props {
  isSectionLoading: boolean;
  hasAnyDeviations: boolean;
  isMobile?: boolean;
  searchQuery: string;
  gallectionType: GallectionType;
}

class GallectionsSection extends React.Component<Props & WithTranslation> {
  componentDidMount() {
    // we don't do route parsing for gallery using react-router anymore
    // so make the back button simply reload the URL it returns to
    window.addEventListener('popstate', this.reloadPage);
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.reloadPage);
  }

  render() {
    const {
      isSectionLoading,
      hasAnyDeviations,
      searchQuery,
      gallectionType,
    } = this.props;

    if (isSectionLoading) {
      return <LoadingIndicator />;
    }

    if (!hasAnyDeviations) {
      return <GallectionEmptyState />;
    }

    if (searchQuery) {
      return <GallectionSearchView />;
    }

    return (
      <BiLoggerContextProvider value={{ sectionname: gallectionType }}>
        <GallectionSimpleView />
      </BiLoggerContextProvider>
    );
  }

  reloadPage = () => {
    window.location.reload();
  };
}

export default withMobileContext(withTranslation()(GallectionsSection));
